import { apiCall } from './generated/gqlClient';

const getHolidaysApiRequest = async () => {
  const query = `
    query getHolidays {
      getHolidays {
        id
        resourceId
        providerId
        startTime
        endTime
        description
        resources {
          id
          userId
          name
        }
      }
    }
  `;

  return apiCall({ query });
};

const getResourceHolidaysApiRequest = async resourceId => {
  const query = `
    query getResourceHolidays($resourceId: Int!) {
      getResourceHolidays(resourceId: $resourceId) {
        id
        resourceId
        providerId
        startTime
        endTime
        description
        resources {
          id
          name
          userId
        }
      }
    }
  `;

  return apiCall({ query, variables: { resourceId } });
};

const removeResourceFromHolidayApiRequest = async (holidayId, resourceId) => {
  const mutation = `
    mutation removeResourceFromHoliday($holidayId: Int!, $resourceId: Int!) {
      removeResourceFromHoliday(holidayId: $holidayId, resourceId: $resourceId) {
        success
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { holidayId, resourceId } });
};

const removeHolidayApiRequest = async holidayId => {
  const mutation = `
    mutation removeHoliday($holidayId: Int!) {
      removeHoliday(holidayId: $holidayId) {
        success
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { holidayId } });
};

export { getHolidaysApiRequest, getResourceHolidaysApiRequest, removeHolidayApiRequest, removeResourceFromHolidayApiRequest };
